import * as d3 from "d3";
import {fw_progressive_1way, inrFormatter, responsivefy} from '../functions'

export default function (chart, divId, vizName, resData) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    //var fontColor = chart.axisFontColor
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    // axios.post(url, filterParam).then(res => {
        /*let jsonFile= chart.jsonFile
    axios({ url: jsonFile, baseURL: '', method: 'GET' }).then(res => {*/
        let data1 = resData
        let datas = data1[0].dim2
        console.log("vizname is", vizName)
        console.log("correlogram data: ", datas)
        var data = []
        datas.forEach(function (d) {
            var x = d['dim']
            delete d['dim']
            for (var prop in d) {
                var y = prop,
                    value = d[prop]
                data.push({
                    x: x,
                    y: y,
                    value: +value
                })
            }
        })

        var domain = d3.set(data.map(d => {
            return d.x
        })).values()

        var num = Math.sqrt(data.length)
        var metric1ColorScale = d3.scaleLinear().domain([-1, 0, 1]).range(fw_progressive_1way)
        var x1Scale = d3.scalePoint().range([0, chart.width]).domain(domain)
        var y1Scale = d3.scalePoint().range([0, chart.height]).domain(domain)
        var x1AxisLabel = x1Scale.range()[1] - x1Scale.range()[0]
        var y1AxisLabel = y1Scale.range()[1] - y1Scale.range()[0]

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width + chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        //tooltip
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
        var y1tip= tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id).html((d) =>{ return inrFormatter(d.value) })

        svg.call(y1tip);*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        var cor = svg.selectAll('.cor')
            .data(data)
            .enter()
            .append('g')
            .attr('class', 'cor')
            .attr('transform', (d) => {
                return 'translate(' + x1Scale(d.x) + ',' + y1Scale(d.y) + ')'
            })

        //edited to fit with d3 update
        cor.append('rect')
            .attr('width', x1AxisLabel / 10)
            .attr('height', y1AxisLabel / 10)
            .attr('x', -x1AxisLabel / 20)
            .attr('y', -y1AxisLabel / 20)
            .attr('stroke', 'lightgray')
            .attr('fill', chart.vizSpecific5)

        cor.filter(d => {
            var ypos = domain.indexOf(d.y)
            var xpos = domain.indexOf(d.x)
            for (var i = (ypos + 1); i < num; i++) {
                if (i === xpos) return false
            }
            return true
        })
            .append('text')
            .attr('y', 5)
            .text(d => {
                if (d.x === d.y) {
                    return d.x
                } else {
                    return inrFormatter(d.value)
                }
            })
            .style("font-size", fontSize)
            .style('fill', d => {
                if (d.value === 1) {
                    return chart.vizSpecific4
                } else {
                    return metric1ColorScale(d.value)
                }
            })
            .style('text-anchor', 'middle')
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(inrFormatter(d.value))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        //.on('mouseover', y1tip.show)
        //.on('mouseleave', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        cor.filter(d => {
            var ypos = domain.indexOf(d.y)
            var xpos = domain.indexOf(d.x)
            for (var i = (ypos + 1); i < num; i++) {
                if (i === xpos) return true
            }
            return false
        })
            .append('circle')
            .attr('r', d => {
                return (chart.width / (num * 2)) * (Math.abs(d.value)) / 2
            })
            .style('fill', d => {
                if (d.value === 1) {
                    return '#000'
                } else {
                    return metric1ColorScale(d.value)
                }
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(inrFormatter(d.value))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        //.on('mouseover', y1tip.show)
        //.on('mouseleave', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        var aS = d3.scaleLinear()
            .range([-chart.margin.top + 25, chart.height + chart.margin.bottom - 10])
            .domain([1, -1])
        var yA = d3.axisRight().scale(aS).tickPadding(7)

        var aG = svg.append('g')
            .attr('class', 'y axis')
            .call(yA)
            .attr('transform', 'translate(' + (chart.width + chart.margin.right / 2) + ' ,0)')

        var iR = d3.range(-1, 1.01, 0.01)
        var h = chart.height / iR.length + 3
        iR.forEach(d => {
            aG.append('rect')
                .style('fill', metric1ColorScale(d))
                .style('stroke-width', 0)
                .style('stoke', 'none')
                .attr('height', h)
                .attr('width', 10)
                .attr('x', 0)
                .attr('y', aS(d))
        })
    // })
}
